interface CardSubtitleProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {}

export default function CardSubtitle({
  children,
  className = '',
  ...rest
}: CardSubtitleProps) {
  return (
    <h3 className={`card-subtitle ${className}`} {...rest}>
      {children}
    </h3>
  );
}
